import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";

const CreaTipoContrato = () => {
  const [tipoContratoId, setTipoContratoId] = useState("");
  const [variableContrato, setVariableContrato] = useState("");
  const [tiposContrato, setTiposContrato] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTiposContrato = async () => {
      try {
        const response = await axios.get(
          "https://contratosback-dev.azurewebsites.net/api/v1/ObtieneTipoContrato",
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          }
        );
        setTiposContrato(response.data);
      } catch (error) {
        console.error("Error al obtener tipos de contrato:", error);
        Swal.fire(
          "Error",
          "No se pudieron cargar los tipos de contrato.",
          "error"
        );
      }
    };
    fetchTiposContrato();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tipoContratoId || !variableContrato.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Por favor complete el tipo de contrato y la variable.",
      });
      return;
    }

    try {
      setLoading(true);

      Swal.fire({
        title: "Guardando...",
        text: "Por favor espere",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post(
        "https://contratosback-dev.azurewebsites.net/api/v1/CreaVariableContratos",
        {
          idTipoContrato: tipoContratoId,
          variable: variableContrato,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        }
      );

      Swal.fire("¡Éxito!", "La variable fue creada correctamente.", "success");
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error("Error al crear variable:", error);
      Swal.fire("Error", "Error al crear variable: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Variables</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <h6 className="heading-small text-muted mb-4">
                    TIPO CONTRATO
                  </h6>
                  <div className="pl-lg-4">
                    <FormGroup>
                      <label className="form-control-label">
                        Tipo de Contrato
                      </label>
                      <Input
                        type="select"
                        value={tipoContratoId}
                        onChange={(e) => setTipoContratoId(e.target.value)}
                        disabled={loading}
                      >
                        <option value="">Seleccione un tipo</option>
                        {tiposContrato.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.tipoContrato}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <label className="form-control-label">Variable</label>
                      <Input
                        type="text"
                        placeholder="Ingrese la variable"
                        value={variableContrato}
                        onChange={(e) => setVariableContrato(e.target.value)}
                        disabled={loading}
                      />
                    </FormGroup>
                    <Button
                      type="submit"
                      color="primary"
                      size="lg"
                      disabled={loading}
                    >
                      {loading ? "Enviando..." : "ENVIAR"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreaTipoContrato;
